import request from '../utils/request';

//调解中心列表
export function mediateList_center(data) {
    return request({
        url: '/api/tiaojie_case_list_center',
        method: 'post',
        data
    });
}

//调解中心立案
export function filingCase_center(data) {
    return request({
        url: '/api/add_tiaojie_case_center',
        method: 'post',
        data
    });
}

//下载模版
export function batchImport_center(data) {
    return request({
        url: '/api/tiaojie_case_tem_url_center',
        method: 'post',
        data
    });
}

//获取商事调解中心列表
export function mediationCenterList() {
    return request({
        url: '/api/get_bind_list_center',
        method: 'post'
    });
}

//批量提交案件至商事调解中心
export function bulkSubmissionCase(data) {
    return request({
        url: '/api/tiaojie_case_batch_submit_center',
        method: 'post',
        data
    });
}

//给商事调解案件批量绑定证据清单
export function evidenceList_center(data) {
    return request({
        url: '/api/batch_bind_tiaojie_evi_center',
        method: 'post',
        data
    });
}

//给商事调解案件绑定补充证据清单
export function supplementary_center(data) {
    return request({
        url: '/api/batch_bind_extra_tiaojie_evi_center',
        method: 'post',
        data
    });
}

//商事调解案件证据材料详情
export function settlementList_center(data) {
    return request({
        url: '/api/tiaojie_case_evidence_detail_center',
        method: 'post',
        data
    });
}

//商事调解中心保存证据清单
export function saveEvidence_center(data) {
    return request({
        url: '/api/tiaojie_case_save_evidence_center',
        method: 'post',
        data
    });
}

//商事调解中心补充证据详情
export function supplementDetails_center(data) {
    return request({
        url: '/api/tiaojie_case_extra_evidetail_center',
        method: 'post',
        data
    });
}

//商事调解中心补充证据 保存
export function mediateSupplement_center(data) {
    return request({
        url: '/api/tiaojie_case_save_extra_evi_center',
        method: 'post',
        data
    });
}

//商事调解中心案件详情
export function mediationDetails_center(data) {
    return request({
        url: '/api/tiaojie_case_detail_center',
        method: 'post',
        data
    });
}

//下载商事调解中心 企业申请人身份证明
export function identityCertificate_center(data) {
    return request({
        url: '/api/com_id_tiaojie_ddall_center',
        method: 'post',
        data
    });
}

//下载商事调解中心 证据清单
export function downloadList_center(data) {
    return request({
        url: '/api/tiaojie_case_dd_zju_center',
        method: 'post',
        data
    });
}

//商事调解中心 申请人其他证据
export function otherEvidence_center(data) {
    return request({
        url: '/api/qita_tiaojie_evi_download_all_center',
        method: 'post',
        data
    });
}

//商事调解中心 补充证据下载
export function supplementaryEvidence_center(data) {
    return request({
        url: '/api/tiaojie_case_dd_extrazju_center',
        method: 'post',
        data
    });
}

//商事调解中心 仲裁文书下载
export function arbitrationDocument_center(data) {
    return request({
        url: '/api/tiaojie_case_dd_wenshu_center',
        method: 'post',
        data
    });
}

//商事调解中心 删除案件
export function deleteCase_center(data) {
    return request({
        url: '/api/tiaojie_case_delete_center',
        method: 'post',
        data
    });
}

//商事调解中心修改立案信息 回显
export function echoInformation_center(data) {
    return request({
        url: '/api/tiaojie_case_edit_detail_center',
        method: 'post',
        data
    });
}

//商事调解中心 保存修改后的信息
export function saveInformation_center(data) {
    return request({
        url: '/api/edit_tiaojie_case_center',
        method: 'post',
        data
    });
}

//查询客户所有模板
export function getClientList(data) {
    return request({
        url: '/api/get_all_tpl_byid',
        method: 'post',
        data
    });
}

//根据批号提交至商事调解中心
export function byLotNumber(data) {
    return request({
        url: '/api/batch_submit_center_bypisn',
        method: 'post',
        data
    });
}
